/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import React from "react";
import {MutableList} from "./MutableList";
import {useSortedData} from "../../../Hooks/ListHooks";
import {RemoveConservationActionPermitItemButton} from "./RemoveConservationActionPermitItemButton";
import {useEditContextNodeId} from "../../../Hooks/PermissionHooks";
import {useAutoCompleteOptionsFilterCallback} from "../../../Hooks/useAutoCompleteOptionsFilterCallback";
import {service as ConservationActionService} from "../../../Services/ConservationActionService";
import {useSelector} from "react-redux";

export const StreamBankPermitConservationActionList = (props) => {
    const {
        AdditionalTypeProps,
        Editable,
        Data,
        sortKey,
    } = props;
    
    const {
        conservationActionContextNodeId = null,
        organizationId = null
    } = useSelector(state => state.contextState.context);
    
    const canEditContextNodeId = useEditContextNodeId();
    const sortedData = useSortedData(Data, sortKey);
    
    const editableData = sortedData?.filter?.(x => canEditContextNodeId(x.contextNodeId) || !x.contextNodeId) ?? [];
    
    const filter = useAutoCompleteOptionsFilterCallback(
        ConservationActionService.PrimaryKeyProperty,
        sortedData,
        (conservationAction) => {
            // filter out any conservationActions that don't match the permitTypeId
            return conservationAction?.organizationId === organizationId
                && canEditContextNodeId(conservationAction.contextNodeId);
    });
    
    return <MutableList
        {...props}
        Data={editableData}
        AdditionalTypeProps={{
            ...AdditionalTypeProps,
            Editable: (item) => (Editable && !item.contextNodeId),
            CustomData: {
                filter,
                additionalSearchParams: {
                    organizationId: organizationId,
                }
            },
        }}
        RemoveItemButton={RemoveConservationActionPermitItemButton}
        
        isItemEditable={(item) => (Editable && item.contextNodeId !== conservationActionContextNodeId)}
        
        />;
};
